// Modul zur Erfassung von Stueckkosten
"use strict";

import module from "./module.js";

export default module;
